export const RESULT_IMAGE_SOURCE =
  'https://raw.githubusercontent.com/TeamCatchMe/CatchMe-If-You-Promotion/main/src/assets/result-cards/';
